import { useCallback } from 'react'
import type { MiniappEmbed } from 'api/lib/unfurl'
import { CHANNEL_INFO_PARAMS } from 'routes'
import { usePanelActions } from 'routes/layouts/hooks/usePanelActions'

type MiniappPanelPayload = {
    miniappUrl: string
    embed?: MiniappEmbed | null
    eventId?: string
}

export const useOpenMiniappPanel = () => {
    const { openPanel } = usePanelActions()

    return useCallback(
        ({ miniappUrl, embed, eventId }: MiniappPanelPayload) => {
            if (!miniappUrl) {
                console.warn('[Miniapp] Attempted to open miniapp panel without URL')
                return
            }

            const payload: MiniappPanelPayload = {
                miniappUrl,
                embed: embed ?? null,
                eventId,
            }

            openPanel(CHANNEL_INFO_PARAMS.MINIAPP, {
                data: JSON.stringify(payload),
            })
        },
        [openPanel],
    )
}
